import React from "react";

export const Store = React.createContext();
export const useStore = () => React.useContext(Store);
